import {CSSProperties} from 'react';

export const HTML_FORM_TOOLBAR_CSS_VARS = {
    '--priority-toolbar-item-min-height': '32px',
    '--priority-toolbar-item-min-width': '32px',
    '--priority-toolbar-item-padding': '4px',
    '--priority-toolbar-item-gaps': '4px',
    '--priority-toolbar-padding': '4px'
} as CSSProperties;
